import React from 'react';
import padIcon from '../../../../assets/DasboardIcons/pad.png';
import HeaderAvatar from '../../../Avatar/HeaderAvatar';
import AppLauncher from '../../../AppLauncher';

const Header = ({
  viewMode,
  onChangeView,
  onToggleSidebar,
  sortDropdownOpen,
  onToggleSort,
  sortOptions = [],
  selectedSort,
  onSelectSort,
}) => {
  // Close dropdown on outside click
  const dropdownRef = React.useRef(null);
  React.useEffect(() => {
    function handleClick(e) {
      if (sortDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onToggleSort?.(); // toggle will close
      }
    }
    if (sortDropdownOpen) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sortDropdownOpen, onToggleSort]);

  return (
    <header className="sticky top-0 z-20 bg-white border-b border-gray-200">
      <div className="pl-0 pr-6 lg:pl-1 lg:pr-8 py-4 flex items-center justify-between w-full">
        <div className="flex items-center gap-2 flex-shrink-0">
          <button className="inline-flex h-9 w-9 items-center justify-center rounded-md hover:bg-gray-100" onClick={onToggleSidebar} aria-label="Toggle sidebar">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="h-5 w-5 text-gray-700"><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
          <div className="flex items-center gap-2">
            <img src={padIcon} alt="Pad" className="h-8 w-8" />
            <span className="text-2xl font-medium">Pad</span>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={onToggleSort}
              className={`inline-flex items-center gap-1.5 text-sm h-9 px-3 rounded-md border border-gray-300 hover:bg-gray-50 text-gray-700 ${sortDropdownOpen ? 'bg-gray-50' : ''}`}
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M6 12h12M10 17h4" />
              </svg>
              {selectedSort?.label || 'Sort'}
              <svg className={`w-4 h-4 transition-transform ${sortDropdownOpen ? 'rotate-180' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {sortDropdownOpen && (
              <div className="absolute right-0 mt-2 w-56 rounded-2xl border border-gray-200 bg-white shadow-xl py-2 z-30">
                {sortOptions.map(opt => {
                  const active = selectedSort?.id === opt.id;
                  return (
                    <button
                      key={opt.id}
                      onClick={() => onSelectSort?.(opt)}
                      className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-gray-50 ${active ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700'}`}
                    >
                      <span>{opt.label}</span>
                      {active && (
                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          <div className="flex items-center h-9 border border-gray-300 rounded-md overflow-hidden">
            <button
              onClick={() => onChangeView('grid')}
              className={`inline-flex items-center justify-center w-12 h-full transition-colors ${viewMode === 'grid' ? 'bg-[#526bb1] text-white' : 'hover:bg-gray-50 text-gray-600'}`}
              title="Grid view"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 3h7v7H3V3zm0 11h7v7H3v-7zm11-11h7v7h-7V3zm0 11h7v7h-7v-7z" />
              </svg>
            </button>
            <div className="w-px h-full bg-gray-300"></div>
            <button
              onClick={() => onChangeView('list')}
              className={`inline-flex items-center justify-center w-12 h-full transition-colors ${viewMode === 'list' ? 'bg-[#526bb1] text-white' : 'hover:bg-gray-50 text-gray-600'}`}
              title="List view"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
              </svg>
            </button>
          </div>
          <AppLauncher />
          <HeaderAvatar isDashboard={true} />
        </div>
      </div>
    </header>
  );
};

export default Header;
